const salonQuotes = [
  {quote: 'The only place where success comes before work is in the dictionary.', author: 'Vidal Sassoon'},
  {quote: "If you don't look good, we don't look good.", author: 'Vidal Sassoon'},
  {
    quote: "Hair is nature's biggest compliment and the treatment of this compliment is in our hands.",
    author: 'Vidal Sassoon'
  },
  {quote: 'We sell hope.', author: 'Eugène Schueller', company: "L'Oréal"},
  {
    quote: "A business that doesn't change is a business that is going to die.",
    author: 'Eugène Schueller',
    company: "L'Oréal"
  },
  {quote: 'I never dreamed about success. I worked for it.', author: 'Estée Lauder', company: 'Estée Lauder Companies'},
  {quote: 'Beauty is an attitude.', author: 'Estée Lauder', company: 'Estée Lauder Companies'},
  {
    quote:
      'I have never worked a day in my life without selling. If I believe in something, I sell it, and I sell it hard.',
    author: 'Estée Lauder',
    company: 'Estée Lauder Companies'
  },
  {
    quote:
      "Aerodynamically, the bumblebee shouldn't be able to fly, but the bumblebee doesn't know it, so it goes on flying anyway.",
    author: 'Mary Kay Ash',
    company: 'Mary Kay Cosmetics'
  },
  {
    quote:
      "Pretend that every single person you meet has a sign around his or her neck that says, 'Make me feel important.' Not only will you succeed in sales, but you will also succeed in life.",
    author: 'Mary Kay Ash',
    company: 'Mary Kay Cosmetics'
  },
  {quote: 'There are no ugly women, only lazy ones.', author: 'Helena Rubinstein'},
  {
    quote: 'Hard work keeps the wrinkles out of the mind and spirit.',
    author: 'Helena Rubinstein'
  },
  {
    quote: "Beauty isn't about looking perfect. It's about celebrating your individuality.",
    author: 'Bobbi Brown',
    company: 'Bobbi Brown Cosmetics'
  },
  {
    quote: 'I believe all women are pretty without makeup – but with the right makeup can be pretty powerful.',
    author: 'Bobbi Brown',
    company: 'Bobbi Brown Cosmetics'
  },
  {
    quote: 'In the factory, we make cosmetics; in the store, we sell hope.',
    author: 'Charles Revson',
    company: 'Revlon'
  },
  {
    quote: 'The most beautiful makeup for a woman is passion. But cosmetics are easier to buy.',
    author: 'Yves Saint Laurent'
  },
  {quote: 'Beauty begins the moment you decide to be yourself.', author: 'Coco Chanel', company: 'Chanel'},
  {
    quote: 'The best color in the whole world is the one that looks good on you.',
    author: 'Coco Chanel',
    company: 'Chanel'
  },
  {
    quote:
      "Makeup can only make you look pretty on the outside, but it doesn't help if you're ugly on the inside. Unless you eat the makeup.",
    author: 'Audrey Hepburn'
  },
  {
    quote: 'Beauty, to me, is about being comfortable in your own skin. That, or a kick-ass red lipstick.',
    author: 'Gwyneth Paltrow',
    company: 'Goop'
  },
  {
    quote: 'The beauty of a woman is not in a facial mole, but true beauty in a woman is reflected in her soul.',
    author: 'Audrey Hepburn'
  },

  {
    quote: 'Customer retention is the heartbeat of our salon; each satisfied client is a step toward success.',
    author: 'Anonymous'
  },
  {
    quote: 'Behind every glowing review is a satisfied customer who felt pampered, not just serviced.',
    author: 'Anonymous'
  },
  {quote: "In the world of beauty, customer satisfaction isn't just a goal – it's a work of art.", author: 'Anonymous'},
  {
    quote: "Marketing isn't just about attracting clients; it's about creating connections that keep them coming back.",
    author: 'Anonymous'
  },
  {
    quote: "Our salon: where every service isn't just an appointment, but an experience worth cherishing.",
    author: 'Anonymous'
  },
  {
    quote: 'A higher average check reflects not just pricing, but the value clients place on our expertise.',
    author: 'Anonymous'
  },
  {quote: 'In a world of choices, our salon stands out by consistently exceeding expectations.', author: 'Anonymous'},
  {
    quote: "Customer loyalty isn't built overnight; it's the result of consistently exceptional experiences.",
    author: 'Anonymous'
  },
  {quote: 'The true measure of success lies not just in bookings, but in the smiles we create.', author: 'Anonymous'},
  {
    quote: 'Each service is a canvas; our artists paint strokes of satisfaction, leaving a masterpiece.',
    author: 'Anonymous'
  },
  {
    quote: "Marketing brings them in, but customer satisfaction brings them back – that's the magic of our salon.",
    author: 'Anonymous'
  },
  {
    quote: 'The path to growth is paved with a commitment to quality; each service is a step forward.',
    author: 'Anonymous'
  },
  {quote: 'Customer satisfaction is our masterpiece; each appointment is a brushstroke.', author: 'Anonymous'},
  {quote: 'Our commitment: turning every visit into a cherished memory.', author: 'Anonymous'},
  {quote: 'In a world of trends, our timeless service speaks volumes.', author: 'Anonymous'},
  {quote: 'Beauty is our language, and client satisfaction is our conversation.', author: 'Anonymous'},
  {quote: 'Every appointment is a chance to create magic in mirrors.', author: 'Anonymous'},
  {quote: "Our salon: where excellence isn't an option, it's a tradition.", author: 'Anonymous'},
  {quote: 'From consultation to completion, your satisfaction is our inspiration.', author: 'Anonymous'},
  {quote: 'Transforming appointments into uplifting experiences, one smile at a time.', author: 'Anonymous'},
  {quote: 'Client satisfaction is the heartbeat of our business rhythm.', author: 'Anonymous'},
  {quote: 'Your happiness is the mirror in which we measure our success.', author: 'Anonymous'},
  {
    quote: 'AI is reshaping the beauty industry, making appointments smarter and services more personalized.',
    author: 'Anonymous'
  },
  {
    quote:
      "In the world of beauty, AI isn't just a tool; it's the artist that understands and fulfills your unique needs.",
    author: 'Anonymous'
  },
  {
    quote:
      'From personalized recommendations to efficient scheduling, AI is the magic wand that elevates salon experiences.',
    author: 'Anonymous'
  },
  {
    quote: 'In the era of AI, every appointment becomes a tailored journey, enhancing satisfaction at every step.',
    author: 'Anonymous'
  },
  {
    quote:
      'AI-powered analytics provide insights that help salons refine services, creating a cycle of continuous improvement.',
    author: 'Anonymous'
  },
  {
    quote:
      'Gone are the days of waiting – AI-driven scheduling ensures your time is valued, and convenience is prioritized.',
    author: 'Anonymous'
  },
  {
    quote:
      'Embracing AI means embracing efficiency; salons are now able to allocate resources and staff with surgical precision.',
    author: 'Anonymous'
  },
  {
    quote:
      'The fusion of human creativity and AI precision is the new masterpiece in the world of beauty appointments.',
    author: 'Anonymous'
  },
  {
    quote:
      'AI is the compass guiding businesses towards customer-centricity, where every appointment is an expression of care.',
    author: 'Anonymous'
  }
]

const salonQuotesAM = [
  {
    quote: 'Վարսերը բնության մեծագույն պարգևն են և այդ պարգևի խնամքը մեր ձեռքերում է:',
    author: 'Վիդալ Սասսուն'
  },
  {quote: 'Մենք վաճառում ենք հույս:', author: 'Eugène Schueller', company: "L'Oréal"},
  {
    quote: 'Բիզնեսը, որը չի փոխվում, դատապարտված է կործանման:',
    author: 'Էուժեն Շուլըղ',
    company: "L'Oréal"
  },
  {
    quote: 'Ես երբեք չեմ երազել հաջողության հասնելու մասին: Ես աշխատել եմ դրա համար:',
    author: 'Էսթե Լոուդր',
    company: 'Estée Lauder Companies'
  },
  {quote: 'Տգեղ կին չի լինում, լինում են միայն ծույլեր:', author: 'Հելենա Րուբինշթայն'},
  {
    quote: 'Քրտնաջան աշխատանքը միտքը և ոգին հեռու է պահում կնճիռներից:',
    author: 'Հելենա Րուբինշթայն'
  },
  {
    quote: 'Գեղեցկությունը անթերի արտաքին ունենալու մեջ չէ, այլ ձեր անհատականությունը տոնելու մասին է:',
    author: 'Բոբբի Բրաուն',
    company: 'Bobbi Brown Cosmetics'
  },

  {
    quote: 'Գործարանում մենք ստեղծում ենք կոսմետի նյութեր, խանութում մենք վաճառում ենք հույս:',
    author: 'Չարլս Րևսոն',
    company: 'Revlon'
  },
  {
    quote: 'Կանանց լավագույն դիմահարդարումը կիրքն է: Սակայն կոսմետիկա գնելը շատ ավելի հեշտ է:',
    author: 'Yves Saint Laurent'
  },
  {
    quote: 'Գեղեցկությունը սկսվում է այն պահին, երբ որոշում ես լինել այնպիսին ինչպիսին կաս:',
    author: 'Կոկո Շանել',
    company: 'Chanel'
  },
  {
    quote:
      'Հաճախորդի հավատարմությունը մեր սրահի սրտի զարկն է, յուրաքանչյուր գոհացված հաճախորդ` քայլ է դեպի հաջողություն:',
    author: 'Անհայտ'
  },
  {
    quote: 'Յուրաքանչյուր փայլուն գնահատականի հետևում գոհացված հաճախորդն է, որը ոչ միայն սպասարկվել է այլ խնամվել:',
    author: 'Անհայտ'
  },
  {quote: 'Գեղեցկության ոլորտում հաճախորդի գոհունակությունը միայն նպատակ չէ, այլ արվեստի գործ:', author: 'Անհայտ'},
  {
    quote: 'Մարքեթինգը միայն հաճախորդներ ներգրավելը չէ, դա այն կապի ստեղծումն է, որը նրանց անընդհատ վերադարձնում է:',
    author: 'Անհայտ'
  },
  {quote: 'Հաճախորդի յուրաքաչյուր այց հայելու մեջ կախարդանք ստեղծելու հնարավորություն է:', author: 'Անհայտ'},
  {
    quote:
      'Արհեստական բանականության դարաշրջանում յուրաքանչյուր այց վերածվում անձնական ճանապարհորդության` բարձրացնելով գոհունակությունը յուրաքանչյուր քայլին:',
    author: 'Անհայտ'
  },
  {quote: 'Գեղեցկությունը մեր լեզուն է, իսկ հաճախորդի գոհունակությունը` զրույցը:', author: 'Անհայտ'}
]

const salonQuotesRU = [
  {quote: 'Единственное место, где успех идет перед работой, это в словаре.', author: 'Видал Сассун'},
  {quote: 'Если вы не выглядите хорошо, то и мы выглядим плохо.', author: 'Видал Сассун'},
  {
    quote: 'Волосы - это самый большой комплимент от природы, и как мы обращаемся с этим комплиментом, зависит от нас.',
    author: 'Видал Сассун'
  },
  {quote: 'Мы продаем надежду.', author: 'Евгений Шуллер', company: "L'Oréal"},
  {
    quote: 'Бизнес, который не меняется, - это бизнес, который умирает.',
    author: 'Евгений Шуллер',
    company: "L'Oréal"
  },
  {
    quote: 'Я никогда не мечтала об успехе. Я работала на него.',
    author: 'Эсте Лаудер',
    company: 'Estée Lauder Companies'
  },
  {quote: 'Красота - это настроение.', author: 'Эсте Лаудер', company: 'Estée Lauder Companies'},
  {
    quote:
      'Я ни дня не работала, не занимаясь продажами. Если я верю во что-то, я это продвигаю, и делаю это с усердием.',
    author: 'Эсте Лаудер',
    company: 'Estée Lauder Companies'
  },
  {
    quote: 'Аэродинамически, шмель не должен уметь летать, но шмель об этом не знает, поэтому продолжает летать.',
    author: 'Мэри Кэй Эш',
    company: 'Mary Kay Cosmetics'
  },
  {
    quote:
      "Представьте, что у каждого человека, которого вы встречаете, на шее висит табличка: 'Заставьте меня чувствовать себя важным.' Не только у вас получится в продажах, но и в жизни вы добьетесь успеха.",
    author: 'Мэри Кэй Эш',
    company: 'Mary Kay Cosmetics'
  },
  {quote: 'Некрасивых женщин не бывает, бывают ленивые.', author: 'Елена Рубинштейн'},
  {
    quote: 'Тяжелая работа убирает морщины с ума и духа.',
    author: 'Елена Рубинштейн'
  },
  {
    quote: 'Красота не в том, чтобы выглядеть идеально. Это отмечание вашей индивидуальности.',
    author: 'Бобби Браун',
    company: 'Bobbi Brown Cosmetics'
  },
  {
    quote: 'Я верю, что все женщины красивы без макияжа – но с правильным макияжем они могут быть еще мощнее.',
    author: 'Бобби Браун',
    company: 'Bobbi Brown Cosmetics'
  },
  {
    quote: 'На фабрике мы делаем косметику; в магазине мы продаем надежду.',
    author: 'Чарльз Ревсон',
    company: 'Revlon'
  },
  {
    quote: 'Самый красивый макияж для женщины - это страсть. Но косметику купить легче.',
    author: 'Ив Сен-Лоран'
  },
  {quote: 'Красота начинается в тот момент, когда вы решаете быть собой.', author: 'Коко Шанель', company: 'Chanel'},
  {
    quote: 'Лучший цвет во всем мире - это тот, который идет вам.',
    author: 'Коко Шанель',
    company: 'Chanel'
  },
  {
    quote:
      'Макияж может сделать вас красивой снаружи, но это не поможет, если вы уродливы внутри. Если только не съесть макияж.',
    author: 'Одри Хепберн'
  },
  {
    quote: 'Красота, по моему мнению, это чувство комфорта в своей собственной коже. Это или крутая красная помада.',
    author: 'Гвинет Пэлтроу',
    company: 'Goop'
  },
  {
    quote: 'Красота женщины не в родинке на лице, а истинная красота женщины отражается в ее душе.',
    author: 'Одри Хепберн'
  },

  {
    quote: 'Удержание клиентов - это сердце нашего салона; каждый довольный клиент - это шаг к успеху.',
    author: 'Анонимный'
  },
  {
    quote:
      'За каждым восторженным отзывом стоит довольный клиент, который чувствовал себя не просто обслуженным, а избалованным.',
    author: 'Анонимный'
  },
  {
    quote: 'В мире красоты удовлетворение клиентов - это не просто цель, это произведение искусства.',
    author: 'Анонимный'
  },
  {
    quote: 'Маркетинг - это не только привлечение клиентов; это создание связей, которые заставляют их возвращаться.',
    author: 'Анонимный'
  },
  {
    quote: 'Наш салон: где каждая услуга - это не просто визит, а ценный опыт.',
    author: 'Анонимный'
  },
  {
    quote: 'Выше средний чек отражает не только цены, но и ценность, которую клиенты придают нашему мастерству.',
    author: 'Анонимный'
  },
  {quote: 'В мире выбора наш салон выделяется, постоянно превосходя ожидания.', author: 'Анонимный'},
  {
    quote: 'Лояльность клиентов не строится за одну ночь; это результат последовательно исключительных впечатлений.',
    author: 'Анонимный'
  },
  {
    quote: 'Истинная мера успеха заключается не только в бронированиях, но и в улыбках, которые мы создаем.',
    author: 'Анонимный'
  },
  {
    quote: 'Каждая услуга - это холст; наши мастера рисуют удовлетворение, оставляя шедевр.',
    author: 'Анонимный'
  },
  {
    quote:
      'Маркетинг привлекает их, но удовлетворение клиентов заставляет их возвращаться - вот в чем волшебство нашего салона.',
    author: 'Анонимный'
  },
  {
    quote: 'Путь к росту вымощен обязательством качества; каждая услуга - это шаг вперед.',
    author: 'Анонимный'
  },
  {
    quote: 'Удовлетворение клиентов - наше произведение искусства; каждая запись - это мазок кисти.',
    author: 'Анонимный'
  },
  {quote: 'Наше обязательство: превращать каждый визит в дорогую память.', author: 'Анонимный'},
  {quote: 'В мире тенденций наше вечное обслуживание говорит само за себя.', author: 'Анонимный'},
  {quote: 'Красота - наш язык, а удовлетворенность клиентов - наш разговор.', author: 'Анонимный'},
  {quote: 'Каждая запись - это шанс создать магию в зеркалах.', author: 'Анонимный'},
  {quote: 'Наш салон: где превосходство - не вариант, а традиция.', author: 'Анонимный'},
  {quote: 'От консультации до завершения, ваше удовлетворение - наше вдохновение.', author: 'Анонимный'},
  {quote: 'Превращаем записи в поднимающие настроение переживания, улыбка за улыбкой.', author: 'Анонимный'},
  {quote: 'Удовлетворение клиентов - это ритм нашего бизнеса.', author: 'Анонимный'},
  {quote: 'Ваше счастье - зеркало, в котором мы измеряем наш успех.', author: 'Анонимный'},
  {
    quote: 'ИИ преображает индустрию красоты, делая записи умнее и услуги более персонализированными.',
    author: 'Анонимный'
  },
  {
    quote:
      'В мире красоты ИИ - это не просто инструмент; это художник, который понимает и удовлетворяет ваши уникальные потребности.',
    author: 'Анонимный'
  },
  {
    quote:
      'От персонализированных рекомендаций до эффективного планирования, ИИ - это волшебная палочка, которая повышает уровень салонных переживаний.',
    author: 'Анонимный'
  },
  {
    quote:
      'В эпоху ИИ каждая запись становится индивидуальным путешествием, увеличивая удовлетворенность на каждом шагу.',
    author: 'Анонимный'
  },
  {
    quote:
      'Аналитика на основе ИИ предоставляет информацию, которая помогает салонам совершенствовать услуги, создавая цикл непрерывного улучшения.',
    author: 'Анонимный'
  },
  {
    quote: 'Конец ожиданиям - планирование на основе ИИ гарантирует ценность вашего времени и приоритет удобства.',
    author: 'Анонимный'
  },
  {
    quote:
      'Принятие ИИ означает принятие эффективности; салоны теперь могут распределять ресурсы и персонал с хирургической точностью.',
    author: 'Анонимный'
  },
  {
    quote: 'Соединение человеческого творчества и точности ИИ - новое произведение искусства в мире красоты.',
    author: 'Анонимный'
  },
  {
    quote:
      'ИИ - это компас, направляющий бизнесы к клиентоориентированности, где каждая запись - это выражение заботы.',
    author: 'Анонимный'
  }
]

module.exports = {
  en: salonQuotes,
  am: salonQuotesAM,
  ru: salonQuotesRU
}
